module.exports = __webpack_public_path__ + "static/3-c3e9ae7560a04935cc73f4a0676ca9fe.jpeg";